document.addEventListener("page:load", () => {
  document.querySelectorAll(".v2-bg-radial").forEach((el) => {
    window.addEventListener("mousemove", (e) => {
      const mouseX = e.clientX;
      const mouseY = e.clientY;

      const { top, left } = el.getBoundingClientRect();

      const centerY = top + el.clientHeight / 2;
      const centerX = left + el.clientWidth / 2;

      const dy = mouseY - centerY;
      const dx = mouseX - centerX;

      el.style.setProperty("--radial-dx", `${dx * 0.35}px`);
      el.style.setProperty("--radial-dy", `${dy * 0.35}px`);
    });
  });
});
